
import React from 'react'
import { connect } from 'react-redux'
import PartnerOrganizations from 'shared_src/dictionaries/partnerOrganizations'

import * as Patient from '../../../selectors/patient'
import {
  bindTargetMixin,
  SaveButton,
  SelectInput
} from '../../shared/FormBuilder'

import './styles.scss'

class OrgranizationsForm extends bindTargetMixin(React.Component) {
  constructor (props) {
    super(props)
    const { partnerOrganization } = props

    const value = {
      partnerOrganization
    }

    this.state = {
      value,
      partnerOrganization: value.partnerOrganization
    }
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  getValue () {
    return { ...this.state.value }
  }

  handleSubmit () {
    const { onSubmit } = this.props
    const value = this.getValue()

    this.setState({ isSubmitting: true })
    if (onSubmit) {
      onSubmit(value)
    }
  }

  render () {
    const { isSubmitting, value, partnerOrganization } = this.state

    const disableSave = partnerOrganization === value.partnerOrganization

    return (
      <div className='nh-case-management'>
        <div className='row'>
          <div className='col-xs-3 nh-status-select'>
            <SelectInput
              name='partnerOrganization'
              options={PartnerOrganizations}
              disabled={this.props.disabled}
              label='Managing Organization'
            />
          </div>
          <div
            className='col-xs-9'
            style={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <SaveButton
              formKey={this.props.formKey}
              onClick={this.handleSubmit}
              disabled={isSubmitting || disableSave || this.props.disabled}
            />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = redux => ({
  partnerOrganization: Patient.getPartnerOrganization(redux),
    userPartnerOrganization: redux?.auth?.profile?.app_metadata?.partner_organization
})

export default connect(mapStateToProps)(OrgranizationsForm)
